export default __webpack_public_path__ + "static/media/kitemark-icon.bec69dec.svg";